<template>
<!--  <div>-->
    <b-form-group >
      <div>

      <label  v-html="fieldsData.label[selectlang]"></label>


<!--{{fieldsData.name}}-->
      <button v-if="fieldsData.selectAllVisible == 1"  class="selectallbtn" type="button" @click="selectAllOptions">Select all</button>


      </div>
      <v-select
          class="required"
          :options="fieldsData['string-array']"
          :reduce="(item) => item.id"
          :value="fieldsData.id"
          label="title"
          :placeholder="fieldsData.hint[selectlang]"

          multiple
          @input="multiChange($event,'new',fieldsData.name,fieldsData.resetField,fieldsData.visibleItem,fieldsData.hideItem,
      fieldsData.requiredItem,fieldsData.nonRequiredItem,fieldsData.maxLength,fieldsData.minLength)"
      />
<!--      <p v-if="!fieldsData.id">Error: Value is empty below Selectfield.</p>-->
<!--      <small class="text-danger" v-if="fieldsData.id==''">{{ fieldsData.error[selectlang] }}</small>-->
      <small class="text-danger " v-if="isvalidationText">{{ fieldsData.validationText[selectlang] }}</small>


<!--<span>{{fieldsData.id}}</span>-->

    </b-form-group>
<!--  </div>-->
</template>


<script>
import vSelect from "vue-select";
// import { useToast } from 'vue-toastification';
export default {

  // props: {
  //   fieldsData: Object,
  // },
  props: ['fieldsData','filteredCities','selectlang'],
  components: {
    vSelect,
  },

  data() {
    return {
      selectedOption: null,
      username: '',
      // errors: [],
      DataArray:{},
      isvalidationText:false,
      defaultOption: {
        id: 0, // Set the default ID here
        title: 'All' // Set the default title here
      },

      fixedOption: { id: '', title: this.fieldsData.hint[this.selectlang] },


    };
  },
  created() {

    // this.fieldsData.id = this.fieldsData.id.split(',').map(item => parseInt(item.trim()));

    // if (this.fieldsData.id !='') {
    if (this.fieldsData.id) {
      if (typeof this.fieldsData.id === 'number') {
        //   // If this.fieldsData.id is a number, convert it to a string
          this.fieldsData.id = this.fieldsData.id.toString();
      }
      // if (typeof this.fieldsData.id === 'string') {
        this.fieldsData.id = this.fieldsData.id.split(',').map(item => parseInt(item.trim()));
        // Split this.fieldsData.id into an array of integers
        if (this.fieldsData.resetField != '') {

          this.multiChange(this.fieldsData.id, 'edit', this.fieldsData.name, this.fieldsData.resetField, this.fieldsData.visibleItem, this.fieldsData.hideItem,
              this.fieldsData.requiredItem, this.fieldsData.nonRequiredItem, this.fieldsData.maxLength, this.fieldsData.minLength)

        }
      // }
      // else if (typeof this.fieldsData.id === 'number') {
      //   // If this.fieldsData.id is a number, convert it to a string
      //   this.fieldsData.id = this.fieldsData.id.toString();
      //
      //   if (this.fieldsData.resetField != '') {
      //     alert('ddh');
      //     alert('shiny1')
      //     this.multiChange(this.fieldsData.id, 'edit', this.fieldsData.name, this.fieldsData.resetField, this.fieldsData.visibleItem, this.fieldsData.hideItem,
      //         this.fieldsData.requiredItem, this.fieldsData.nonRequiredItem, this.fieldsData.maxLength, this.fieldsData.minLength)
      //
      //   }
      //
      // }
    }
    else{
      this.$emit('targetfield', this.fieldsData.targetField)
    }



  },
  computed: {
    // optionsList() {
    //   if (this.fieldsData.selectAllVisible == 1) {
    //     return [this.defaultOption, ...this.fieldsData['string-array']];
    //   } else {
    //     return this.fieldsData['string-array'];
    //   }
    // }
  },
  watch: {
    // selectedOptions(newVal) {
    //   if (newVal.includes(this.defaultOption)) {
    //     // If "Select All" option is selected, set all other options as selected
    //     this.selectedOptions = this.optionsList.slice(1); // Select all options except the "Select All" option
    //   }
    // }
  },
  methods :{
    selectAllOptions() {
      this.fieldsData.id = this.fieldsData['string-array'].map(item => item.id);
      this.multiChange(this.fieldsData.id, 'new', this.fieldsData.name, this.fieldsData.resetField, this.fieldsData.visibleItem, this.fieldsData.hideItem,
          this.fieldsData.requiredItem, this.fieldsData.nonRequiredItem, this.fieldsData.maxLength, this.fieldsData.minLength)
    },

    showToast() {
     // alert('yes');
      this.isvalidationText = true;

      // Hide the toast after a certain duration
      setTimeout(() => {

        this.isvalidationText = false;
      }, 3000); // Adjust the duration as needed
    },
    validateCheck(vals){
      console.log('emmm',vals);
      if(vals){
        return 1;
      }else {
        return 0;
      }
    },
    UpdateValue(value) {
      // console.log(value);
      this.$emit('input', value)
      // this.$emit('targetfield', this.fieldsData.name)

    },
    multiChange(districtid,action,fieldname,resetField,visibleItem,hideItem,requiredItem,nonRequiredItem,maxsel,minsel){
      // alert(districtid.length);
      console.log('no',minsel);
      // console.log(maxsel);

      if (districtid.length > parseInt(maxsel)) {
        // const toast = useToast();
        //
        // // Example toast notifications
        // toast.success('Success message');

        this.showToast();
        event.preventDefault(); // Prevent the selection from changing
        return; // Stop further execution
      }
      // alert(resetField);
      const visibilityChanges = [];
      const requiredChanges = [];

      // Pushing visibleItem and hideItem into the visibilityChanges array
      if (visibleItem) {
        visibilityChanges.push("show:" + visibleItem);
      }

      if (hideItem) {
        visibilityChanges.push("hide:" + hideItem);
      }
      if (requiredItem) {
        requiredChanges.push("required:" + requiredItem);
      }

      if (nonRequiredItem) {
        requiredChanges.push("nonrequired:" + nonRequiredItem);
      }

      this.$emit('multiChange', districtid,action,fieldname, resetField,visibilityChanges,requiredChanges);

      this. UpdateValue(districtid);

    },


  },
}
</script>
<style>
.selectallbtn{
  color: white;
  background: blue;
  border-radius: 15px;
  border: 2px solid blue;
  padding: 2px;
  padding: 0px 7px;
  border: 2px solid lightgray;

  //margin: 5px 20px;
  //float: right;


}

</style>


